var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',[_c('nuxt-link',{attrs:{"to":_vm.row.detailLocation}},[_vm._v(" "+_vm._s(_vm.value)+" ")]),_c('br'),_c('span',{staticClass:"text-small text-muted"},[_vm._v(" "+_vm._s(_vm.row.imageDisplay)+" ")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }